<div
  id="standard-modal"
  role="dialog"
  aria-labelledby="standard-modalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog modal-xl">
    <div class="modal-content">
      <div class="modal-header mb-4">
        <h4 class="modal-title" id="standard-modalLabel">
          {{ 'contactGroup.list.title' | translate }}
        </h4>

        <button
          type="button"
          [matDialogClose]=""
          class="btn-close"
          data-bs-dismiss="modal"
          aria-hidden="true"
        ></button>
      </div>
      <div class="modal-body">
        @if(contactsByGroup.length > 0) {
        <div class="mb-4">
          <input
            type="text"
            [placeholder]="'contactGroup.list.searchContact' | translate"
            class="form-control"
            [formControl]="searchControl"
          />
        </div>
        <div class="card">
          <div class="card-body table-responsive">
            @if(!loadingContent && filteredContacts.length > 0) {
            <table class="table table-hover table-centered mb-0">
              <thead>
                <tr>
                  <th class="text-primary-emphasis">{{ 'contactGroup.list.columnName' | translate }}</th>
                  <th class="text-primary-emphasis">{{ 'contactGroup.list.columnEmail' | translate }}</th>
                  <th class="text-primary-emphasis">{{ 'contactGroup.list.columnPhone' | translate }}</th>
                </tr>
              </thead>
              <tbody>
                @for (item of filteredContacts; track item) {
                <tr>
                  <td>
                    <span>
                      {{ item?.name ?? "-" }}
                    </span>
                  </td>
                  <td>
                    <span> {{ item?.email ?? "-" }} </span>
                  </td>
                  <td>
                    <span>
                      {{ item?.phone ?? "-" }}
                    </span>
                  </td>
                </tr>
                }
              </tbody>
            </table>
            } @else {
            <empty-records-component
              [message]="'contactGroup.list.emptySearchMessage' | translate"
              [icon]="'mdi mdi-alert-circle-outline'"
              [subMessage]="'contactGroup.list.emptySearchSubMessage' | translate"
            />}
          </div>
        </div>
        } @else {
        <empty-records-component
          [message]="'contactGroup.list.emptyMessage' | translate"
          [icon]="'mdi mdi-alert-circle-outline'"
          [subMessage]="'contactGroup.list.emptySubMessage' | translate"
        />
        }
      </div>
    </div>
  </div>
</div>
